// extracted by mini-css-extract-plugin
export var cardLayout = "_8i-1";
export var paginationContainer = "_8i-0";